import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NodataLabelComponent } from './nodata-label.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [NodataLabelComponent],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    NodataLabelComponent
  ]
})
export class NodataLabelModule { }
